/* HARMONY — QR CODE
   Portado 1:1 do protótipo (harmony-prototype.html, var HarmonyQR).
   Codificador mínimo, modo byte, blocos únicos. Versões 1–5, correção M
   (preferida) ou L (mais capacidade). Escrito à mão porque o certificado
   precisa gerar o QR do próprio código no navegador, sem CDN e sem
   biblioteca externa. Suficiente para uma URL de verificação (até ~106
   bytes). Usado por assets/certificates.js. */
var HarmonyQR = (function () {
  // ---------- GF(256), polinômio 0x11D ----------
  var EXP = new Array(512), LOG = new Array(256);
  (function () {
    var x = 1;
    for (var i = 0; i < 255; i++) {
      EXP[i] = x; LOG[x] = i;
      x <<= 1;
      if (x & 0x100) x ^= 0x11D;
    }
    for (var j = 255; j < 512; j++) EXP[j] = EXP[j - 255];
  })();
  function gmul(a, b) { return (!a || !b) ? 0 : EXP[LOG[a] + LOG[b]]; }

  function rsGenPoly(n) {
    var g = [1];
    for (var i = 0; i < n; i++) {
      var ng = new Array(g.length + 1);
      for (var z = 0; z < ng.length; z++) ng[z] = 0;
      for (var j = 0; j < g.length; j++) {
        ng[j] ^= g[j];
        ng[j + 1] ^= gmul(g[j], EXP[i]);
      }
      g = ng;
    }
    return g;
  }

  function rsEncode(data, nEc) {
    var g = rsGenPoly(nEc);
    var res = data.slice();
    for (var p = 0; p < nEc; p++) res.push(0);
    for (var i = 0; i < data.length; i++) {
      var coef = res[i];
      if (coef !== 0) for (var j = 0; j < g.length; j++) res[i + j] ^= gmul(g[j], coef);
    }
    return res.slice(data.length);
  }

  // ---------- tabela de versões (somente blocos únicos) ----------
  // ecBits: L=1, M=0 (codificação do format info)
  var SPECS = [
    { v: 1, ec: 'M', ecBits: 0, data: 16, ecw: 10 },
    { v: 1, ec: 'L', ecBits: 1, data: 19, ecw: 7 },
    { v: 2, ec: 'M', ecBits: 0, data: 28, ecw: 16 },
    { v: 2, ec: 'L', ecBits: 1, data: 34, ecw: 10 },
    { v: 3, ec: 'M', ecBits: 0, data: 44, ecw: 26 },
    { v: 3, ec: 'L', ecBits: 1, data: 55, ecw: 15 },
    { v: 4, ec: 'L', ecBits: 1, data: 80, ecw: 20 },
    { v: 5, ec: 'L', ecBits: 1, data: 108, ecw: 26 }
  ];
  var ALIGN = { 1: [], 2: [6, 18], 3: [6, 22], 4: [6, 26], 5: [6, 30] };

  function utf8Bytes(str) {
    var out = [];
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      if (c < 0x80) out.push(c);
      else if (c < 0x800) { out.push(0xC0 | (c >> 6), 0x80 | (c & 63)); }
      else if (c < 0xD800 || c >= 0xE000) { out.push(0xE0 | (c >> 12), 0x80 | ((c >> 6) & 63), 0x80 | (c & 63)); }
      else { // par surrogate
        i++;
        var cp = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out.push(0xF0 | (cp >> 18), 0x80 | ((cp >> 12) & 63), 0x80 | ((cp >> 6) & 63), 0x80 | (cp & 63));
      }
    }
    return out;
  }

  function pickSpec(nBytes) {
    for (var i = 0; i < SPECS.length; i++) {
      if (nBytes <= SPECS[i].data - 2) return SPECS[i];   // 12 bits de cabeçalho
    }
    return null;
  }

  function makeCodewords(bytes, spec) {
    var bits = [];
    function push(val, len) { for (var i = len - 1; i >= 0; i--) bits.push((val >> i) & 1); }
    push(4, 4);                  // modo byte
    push(bytes.length, 8);       // contador (versões 1–9)
    for (var i = 0; i < bytes.length; i++) push(bytes[i], 8);

    var capBits = spec.data * 8;
    var term = Math.min(4, capBits - bits.length);
    push(0, term);
    while (bits.length % 8 !== 0) bits.push(0);

    var data = [];
    for (var k = 0; k < bits.length; k += 8) {
      var b = 0;
      for (var j = 0; j < 8; j++) b = (b << 1) | bits[k + j];
      data.push(b);
    }
    var pads = [0xEC, 0x11], pi = 0;
    while (data.length < spec.data) data.push(pads[pi++ % 2]);

    return data.concat(rsEncode(data, spec.ecw));
  }

  function maskAt(mask, r, c) {
    switch (mask) {
      case 0: return (r + c) % 2 === 0;
      case 1: return r % 2 === 0;
      case 2: return c % 3 === 0;
      case 3: return (r + c) % 3 === 0;
      case 4: return (Math.floor(r / 2) + Math.floor(c / 3)) % 2 === 0;
      case 5: return ((r * c) % 2) + ((r * c) % 3) === 0;
      case 6: return (((r * c) % 2) + ((r * c) % 3)) % 2 === 0;
      case 7: return (((r + c) % 2) + ((r * c) % 3)) % 2 === 0;
    }
    return false;
  }

  function baseMatrix(spec) {
    var size = 17 + 4 * spec.v;
    var m = [], fn = [];
    for (var i = 0; i < size; i++) {
      m.push(new Array(size).fill(0));
      fn.push(new Array(size).fill(false));
    }
    function set(r, c, v) {
      if (r < 0 || c < 0 || r >= size || c >= size) return;
      m[r][c] = v ? 1 : 0; fn[r][c] = true;
    }
    // localizadores + separadores
    [[0, 0], [0, size - 7], [size - 7, 0]].forEach(function (p) {
      for (var r = -1; r <= 7; r++) for (var c = -1; c <= 7; c++) {
        var inside = (r >= 0 && r <= 6 && c >= 0 && c <= 6);
        var v = 0;
        if (inside) {
          var border = (r === 0 || r === 6 || c === 0 || c === 6);
          var core = (r >= 2 && r <= 4 && c >= 2 && c <= 4);
          v = (border || core) ? 1 : 0;
        }
        set(p[0] + r, p[1] + c, v);
      }
    });
    // temporização
    for (var i2 = 8; i2 < size - 8; i2++) {
      set(6, i2, i2 % 2 === 0 ? 1 : 0);
      set(i2, 6, i2 % 2 === 0 ? 1 : 0);
    }
    // alinhamento
    var AL = ALIGN[spec.v];
    for (var a = 0; a < AL.length; a++) for (var b = 0; b < AL.length; b++) {
      var ar = AL[a], ac = AL[b];
      if ((ar <= 8 && ac <= 8) || (ar <= 8 && ac >= size - 9) || (ar >= size - 9 && ac <= 8)) continue;
      for (var r2 = -2; r2 <= 2; r2++) for (var c2 = -2; c2 <= 2; c2++) {
        set(ar + r2, ac + c2, Math.max(Math.abs(r2), Math.abs(c2)) !== 1 ? 1 : 0);
      }
    }
    // módulo escuro + reserva do format info
    set(size - 8, 8, 1);
    for (var i3 = 0; i3 <= 8; i3++) { if (!fn[8][i3]) set(8, i3, 0); if (!fn[i3][8]) set(i3, 8, 0); }
    for (var i4 = 0; i4 < 8; i4++) {
      if (!fn[8][size - 1 - i4]) set(8, size - 1 - i4, 0);
      if (!fn[size - 1 - i4][8]) set(size - 1 - i4, 8, 0);
    }
    return { m: m, fn: fn, size: size };
  }

  function placeData(base, codewords, mask) {
    var size = base.size, m = base.m, fn = base.fn;
    var out = m.map(function (row) { return row.slice(); });
    var bitIdx = 0, total = codewords.length * 8, up = true;
    for (var col = size - 1; col > 0; col -= 2) {
      if (col === 6) col--;
      for (var i = 0; i < size; i++) {
        var row = up ? (size - 1 - i) : i;
        for (var k = 0; k < 2; k++) {
          var c = col - k;
          if (fn[row][c]) continue;
          var bit = 0;
          if (bitIdx < total) {
            bit = (codewords[bitIdx >> 3] >> (7 - (bitIdx & 7))) & 1;
            bitIdx++;
          }
          if (maskAt(mask, row, c)) bit ^= 1;
          out[row][c] = bit;
        }
      }
      up = !up;
    }
    return out;
  }

  function placeFormat(m, size, ecBits, mask) {
    var data = (ecBits << 3) | mask;
    var rem = data;
    for (var i = 0; i < 10; i++) rem = (rem << 1) ^ ((rem >> 9) * 0x537);
    var bits = ((data << 10) | rem) ^ 0x5412;
    function bit(i) { return (bits >> i) & 1; }
    for (var i2 = 0; i2 <= 5; i2++) m[i2][8] = bit(i2);
    m[7][8] = bit(6);
    m[8][8] = bit(7);
    m[8][7] = bit(8);
    for (var i3 = 9; i3 < 15; i3++) m[8][14 - i3] = bit(i3);
    for (var i4 = 0; i4 < 8; i4++) m[8][size - 1 - i4] = bit(i4);
    for (var i5 = 8; i5 < 15; i5++) m[size - 15 + i5][8] = bit(i5);
    m[size - 8][8] = 1;
    return m;
  }

  function penalty(m, size) {
    var score = 0, r, c, i;
    // regra 1 — sequências de 5+
    for (r = 0; r < size; r++) {
      var run = 1;
      for (c = 1; c < size; c++) {
        if (m[r][c] === m[r][c - 1]) { run++; if (run === 5) score += 3; else if (run > 5) score++; }
        else run = 1;
      }
    }
    for (c = 0; c < size; c++) {
      var run2 = 1;
      for (r = 1; r < size; r++) {
        if (m[r][c] === m[r - 1][c]) { run2++; if (run2 === 5) score += 3; else if (run2 > 5) score++; }
        else run2 = 1;
      }
    }
    // regra 2 — blocos 2x2
    for (r = 0; r < size - 1; r++) for (c = 0; c < size - 1; c++) {
      var v = m[r][c];
      if (v === m[r][c + 1] && v === m[r + 1][c] && v === m[r + 1][c + 1]) score += 3;
    }
    // regra 3 — padrão 1:1:3:1:1
    var P1 = [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0];
    var P2 = [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1];
    function match(arr, pat) {
      for (var z = 0; z < pat.length; z++) if (arr[z] !== pat[z]) return false;
      return true;
    }
    for (r = 0; r < size; r++) for (c = 0; c + 11 <= size; c++) {
      var seg = m[r].slice(c, c + 11);
      if (match(seg, P1) || match(seg, P2)) score += 40;
    }
    for (c = 0; c < size; c++) for (r = 0; r + 11 <= size; r++) {
      var segv = [];
      for (i = 0; i < 11; i++) segv.push(m[r + i][c]);
      if (match(segv, P1) || match(segv, P2)) score += 40;
    }
    // regra 4 — proporção de escuros
    var dark = 0;
    for (r = 0; r < size; r++) for (c = 0; c < size; c++) dark += m[r][c];
    var pct = dark * 100 / (size * size);
    score += Math.floor(Math.abs(pct - 50) / 5) * 10;
    return score;
  }

  /* Devolve { size, modules:[[0|1]] } ou null se o texto não couber. */
  function encode(text) {
    var bytes = utf8Bytes(String(text));
    var spec = pickSpec(bytes.length);
    if (!spec) return null;
    var cw = makeCodewords(bytes, spec);
    var base = baseMatrix(spec);
    var best = null, bestScore = Infinity;
    for (var mask = 0; mask < 8; mask++) {
      var m = placeData(base, cw, mask);
      placeFormat(m, base.size, spec.ecBits, mask);
      var s = penalty(m, base.size);
      if (s < bestScore) { bestScore = s; best = m; }
    }
    return { size: base.size, modules: best, version: spec.v, ec: spec.ec };
  }

  /* Caminho SVG único com todos os módulos escuros — leve e nítido
     em qualquer escala, sem <rect> por módulo. */
  function toPath(qr) {
    var d = '';
    for (var r = 0; r < qr.size; r++) {
      for (var c = 0; c < qr.size; c++) {
        if (qr.modules[r][c]) d += 'M' + c + ',' + r + 'h1v1h-1z';
      }
    }
    return d;
  }

  return { encode: encode, toPath: toPath };
})();
